import RacsTesztlapTableService from 'app/admin/racstesztlap/service/RacsTesztlapTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'racsTesztlapTable',
	text: 'Rács megadása',
	textKey: 'gridsheet',
	service: RacsTesztlapTableService,
	icon: 'person',
	editFormState: item => `/racstesztlap/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csomagNev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csomagNev',
			text: 'Csomag neve',
			textKey: 'csomagNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feltoltoTesztlapNev',
			text: 'Feltöltő',
			textKey: 'feltoltoTesztlapNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feltoltesIdeje',
			text: 'Feltöltés ideje',
			textKey: 'feltoltesIdeje',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'vonalkodVizsga',
			text: 'Vizsga vonalkódja',
			textKey: 'vonalkodVizsga',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'vonalkodVizsgazo',
			text: 'Vizsgázó vonalkód',
			textKey: 'vonalkodVizsgazo',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'hibaXML',
			text: 'Hiba',
			textKey: 'hibaXML',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function RacsTesztlapTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('racsTesztlapTable', reducer('racsTesztlapTable'))(RacsTesztlapTable);
